// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const CreatePortfolioModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-createportfoliomodalcontainer" */ "./CreatePortfolioModalContainer")).then((bundle)=>{
        return {
            default: bundle.CreatePortfolioModalContainer
        };
    });
export const LazyCreatePortfolioModalContainer = /*#__PURE__*/ lazy(CreatePortfolioModalContainerLazyLoader);
